import { KonanAPI } from "../../services/KonanAPI"
import { validationSchema as rulesetValidationSchema } from "../Ruleset/components/RulesetCard"
import { validationSchema as scoretableValidationSchema } from "../ScoreTables/ScoreTable"
import { validationSchema as scorecardValidationSchema } from "../Scorecards/components/Scorecard"
import { validationSchema as taglistValidationSchema } from "../Taglist"

export const LISTING_QUERY_FUNCTIONS_MAPPER = {
  Taglist: KonanAPI.fetchTagLists,
  Ruleset: KonanAPI.fetchRulesets,
  Scorecard: KonanAPI.fetchScorecards,
} as const

export const DATA_FETCHING_QUERY_FUNCTIONS_MAPPER = {
  Taglist: KonanAPI.fetchTaglist,
  Ruleset: KonanAPI.fetchRuleset,
  Scorecard: KonanAPI.fetchScorecard,
} as const

export const CREATE_MUTATION_FN_MAPPER = {
  Taglist: KonanAPI.createTaglist,
  Ruleset: KonanAPI.createRuleset,
  Scorecard: KonanAPI.createScorecard,
} as const

export const VALIDATION_SCHEMAS_MAPPER = {
  Taglist: taglistValidationSchema,
  Ruleset: rulesetValidationSchema,
  Scorecard: {
    Scorecard: scorecardValidationSchema,
    Scoretable: scoretableValidationSchema,
  },
} as const
